// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1N59s","box":"WorkspacesBox_box__2S8bp","node":"WorkspacesBox_node__2GBtG"};